import React from "react";
import PropTypes from "prop-types";
import PasswordCondition from "../common/BasicSnackbar/PasswordCondition";
import { useTranslation } from "../../context/TranslationContext";

const PasswordConditionsList = ({ conditions, isFocused }) => {
	const { translate } = useTranslation();

	return (
		<>
			<PasswordCondition conditionMet={conditions.length} label={translate("authForm.passwordConditions.minCharacters")} isFocused={isFocused} />
			<PasswordCondition conditionMet={conditions.hasNumber} label={translate("authForm.passwordConditions.containsNumber")} isFocused={isFocused} />
			<PasswordCondition conditionMet={conditions.hasSpecialChar} label={translate("authForm.passwordConditions.containsSpecialChar")} isFocused={isFocused} />
			<PasswordCondition conditionMet={conditions.hasUppercase} label={translate("authForm.passwordConditions.containsUppercase")} isFocused={isFocused} />
			<PasswordCondition conditionMet={conditions.hasLowercase} label={translate("authForm.passwordConditions.containsLowercase")} isFocused={isFocused} />
		</>
	);
};

PasswordConditionsList.propTypes = {
	conditions: PropTypes.shape({
		length: PropTypes.bool.isRequired,
		hasNumber: PropTypes.bool.isRequired,
		hasSpecialChar: PropTypes.bool.isRequired,
		hasUppercase: PropTypes.bool.isRequired,
		hasLowercase: PropTypes.bool.isRequired,
	}).isRequired,
	isFocused: PropTypes.bool.isRequired,
};

export default PasswordConditionsList;
